






































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import VerifyPhoneMixin from '@/apps/open/mixins/VerifyPhone'
import { EVerifyPhoneAction } from '@/apps/open/types'
import { deleteAppAuthConfigs } from '@/apps/open/services/app'
import { onRequestError } from '@/apps/open/utils'
import Button from '@components/Button'
import { priUrlReg } from '@/apps/open/constants'

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Auth extends Mixins(VerifyPhoneMixin) {
  actionType: string = 'edit'
  labelWidth: string = '150px'
  originAppAuthConfigs: any = null
  appAuthConfigs :any = {
    auth_type: 'oauth',
    platform_code: '',
    redirect_uri: '',
    state: '',
    code_url: '',
    access_token_url: '',
    auth_url: '',
    wps_pc_auth_url: '',
    wps_mobile_auth_url: '',
    h5_auth_url: '',
    bind_mode: ['phone'],
    app_id: '',
    third_app_key: '',
    code: '',
    access_token: '',
    union_id: '',
    name: '',
    avatar: ''
  }
  open_ssid = ''
  validRules: any = { 'en.num': /[^0-9a-zA-Z]/g, 'en.num.symbol': /[^0-9a-zA-Z!-~]/g, 'http.https': /^!(h|ht|htt|http|https)/ }
  loading: boolean = true
  oauthParamsTips: any[] = [
    { title: 'APPID', content: 'APPID是第三方应用的识别码' },
    { title: 'SECRET_KEY', content: 'SECRET_KEY是第三方应用的独立访问秘钥' },
    { title: '授权页面地址', content: '授权页面地址是第三方账号授权登录WPS时的第三方授权页面地址，可包含固定参数' },
    { title: '重定向uri字段（示例：redirect_uri）', content: '第三方授权页面回调地址字段名' },
    { title: 'state字段（示例：state）', content: '第三方授权页state参数字段名' },
    { title: '授权码接口地址', content: '第三方服务获取oauth code接口地址，可包含固定参数' },
    { title: '授权码字段（示例：oauth_code）', content: '临时的用户授权凭证，WPS用于换取第三方应用的授权令牌' },
    { title: '授权令牌接口地址', content: '第三方服务获取access_token接口地址，可包含固定参数' },
    { title: '授权令牌字段（示例：access_token）', content: '有时效的授权令牌凭证，WPS用于调用第三方应用的授权接口' },
    { title: '用户标识字段（示例：union_id）', content: '第三方应用的用户id字段，用户授权登录后，WPS才会获取' },
    { title: '用户昵称字段（示例：nickname）', content: '第三方应用的用户昵称字段，用户授权登录后，WPS才会获取' },
    { title: '用户头像字段（示例：avatar）', content: '第三方应用的用户头像字段，用户授权登录后，WPS才会获取' }
  ]
  propertyTips: any[] = [
    { title: '企业代码', content: '企业代码是用于第三方账号登录WPS的一种方式' },
    // { title: '单点登录UA关键字', content: '第三方应用触发单点登录WPS的UA关键字' },
    { title: 'WPS绑定方式', content: '第三方应用可以选择第三方账号首次登录WPS显示的绑定方式' }
    // { title: '加入企业行为', content: '第三方应用可以设置用户同步加入企业、异步加入企业' },
    // { title: '加入企业方式', content: '第三方应用可以设置用户加入企业的方式，2种方式：激活、认证' }
  ]

  authUrlType: number = 0;

  get authUrlTypeOptions () {
    return [{
      value: 0,
      label: '统一地址'
    },
    {
      value: 1,
      label: '各端地址'
    }]
  }

  get multiEndRules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的地址' } : { type: 'url', message: '请输入正确的地址' }
    return {
      wps_pc_auth_url: [
        { required: true, message: `请输入PC客户端授权地址`, trigger: 'blur' },
        { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' },
        urlRule
      ],
      auth_url: [
        { required: true, message: `请输入Web端授权地址`, trigger: 'blur' },
        { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' },
        urlRule
      ],
      wps_mobile_auth_url: [
        { required: true, message: `请输入移动端授权地址`, trigger: 'blur' },
        { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' },
        urlRule
      ],
      h5_auth_url: [
        { required: true, message: `请输入H5授权地址`, trigger: 'blur' },
        { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' },
        urlRule
      ]
    }
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的地址' } : { type: 'url', message: '请输入正确的地址' }
    return {
      platform_code: [
        { required: true, message: `请输入企业代码`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      // h5_ua: [
      //   { required: true, message: `请输入单点登录UA`, trigger: 'blur' }, { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
      // ],
      bind_mode: [
        { type: 'array', required: true, message: `请至少选择一个WPS绑定方式`, trigger: 'change' }
      ],
      third_app_id: [
        { required: true, message: `APPID`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      auth_url: [
        this.authUrlType === 0 && { required: true, message: `授权页面地址`, trigger: 'blur' },
        { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' },
        this.authUrlType === 1 ? { validator: this.verifyAuthUrl } : urlRule
      ],
      redirect_uri: [
        { required: true, message: `重定向uri字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      state: [
        { required: true, message: `state字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      code_url: [
        { required: true, message: `授权码接口地址`, trigger: 'blur' }, { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' }, urlRule
      ],
      access_token_url: [
        { required: true, message: `授权令牌接口地址`, trigger: 'blur' }, { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' }, urlRule
      ],
      third_app_key: [
        { required: true, message: `SECRET_KEY`, trigger: 'blur' }, { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
      ],
      code: [
        { required: true, message: `授权码字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      access_token: [
        { required: true, message: `授权令牌字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      union_id: [
        { required: true, message: `用户标识字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      name: [
        { required: true, message: `用户昵称字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ],
      avatar: [
        { required: true, message: `用户头像字段`, trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
      ]
    }
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get appId () {
    return this.$route.params.id
  }
  get isEdit () {
    return !!this.appId
  }
  get isAppAdmin () {
    return this.$store.getters['isAppAdmin']
  }
  get authFromElement (): any {
    return this.$refs.authFrom as Vue & { offsetWidth: number }
  }
  get modeFormat () {
    const map:any = {
      wechat: '微信登录',
      qq: 'QQ登录',
      phone: '手机登录'
    }
    return this.appAuthConfigs.bind_mode.map((i:any) => {
      return map[i]
    }).join(',')
  }

  async mounted () {
    await this.$store.dispatch('Admin/GET_ADMIN_LIST')
    await this.loadAppAuthConfigs()
  }

  inputValidHandle (prop:string, rule:string) {
    this.appAuthConfigs[prop] = this.appAuthConfigs[prop].replace(rule, '')
  }

  handleAuthUrlPreSave () {
    if (this.authUrlType === 0) {
      this.appAuthConfigs.wps_pc_auth_url = ''
      this.appAuthConfigs.h5_auth_url = ''
      this.appAuthConfigs.wps_mobile_auth_url = ''
    }
  }

  async save () {
    if (await this.validateFrom()) {
      this.handleAuthUrlPreSave()
      if (!this.originAppAuthConfigs) {
        try {
          await this.$store.dispatch('App/SAVE_APP_AUTH_CONFIGS', this.formatOuterConfigs(this.appAuthConfigs))
          this.actionType = 'view'
          this.$message.success('创建成功')
          await this.loadAppAuthConfigs()
        } catch (error) {
          onRequestError(error)
        }
      } else {
        try {
          await this.$store.dispatch('App/UPDATE_APP_AUTH_CONFIGS', this.formatOuterConfigs(this.appAuthConfigs))
          this.actionType = 'view'
          this.$message.success('修改成功')
          await this.loadAppAuthConfigs()
        } catch (error) {
          onRequestError(error)
        }
      }
    }
  }

  verifyAuthUrl (rule: unknown, value: string, cb: Function) {
    this.$refs.authUrlForm && (this.$refs.authUrlForm as Vue & {validate: Function}).validate((valid: boolean, info: object) => {
      if (valid) {
        cb()
      }
    })
  }

  validateFrom () {
    return new Promise((resolve) => {
      this.authFromElement.validate((a:boolean, b:any) => {
        resolve(a)
      })
    })
  }

  // 加载配置信息
  async loadAppAuthConfigs () {
    try {
      await this.$store.dispatch('App/GET_APP_AUTH_CONFIGS', this.appId)
      const data = this.$store.getters['App/appAuthConfigs']
      this.actionType = 'view'
      this.originAppAuthConfigs = data
      this.formatInnerConfigs()
    } catch (error) {
      this.originAppAuthConfigs = null
      if (error.message === 'auth config not exists') {
        this.actionType = 'edit'
      } else {
        !this.isPrivate && onRequestError(error)
        this.actionType = 'view'
      }
    }
    this.loading = false
  }

  // 格式处理
  formatInnerConfigs () {
    this.appAuthConfigs = Object.assign({}, this.originAppAuthConfigs, this.originAppAuthConfigs.oauth_cfg)
    this.appAuthConfigs.bind_mode = this.appAuthConfigs.bind_mode.replace(/\s+/g, '').split(',')
  }

  // 反格式处理
  formatOuterConfigs (data: any) {
    const oAuthConfigs = ['third_app_id', 'third_app_key', 'redirect_uri', 'auth_url', 'wps_mobile_auth_url', 'wps_pc_auth_url', 'h5_auth_url', 'access_token_url', 'access_token', 'code', 'state', 'code_url', 'union_id', 'name', 'avatar']
    const authConfigs = ['platform_code', 'h5_ua', 'auth_type', 'bind_mode']

    let v = { oauth_cfg: {} as any } as any
    for (const key in data) {
      if (oAuthConfigs.includes(key)) {
        v.oauth_cfg[key] = data[key]
      } else if (authConfigs.includes(key)) {
        v[key] = data[key]
      }
    }

    v.app_id = this.appId
    v.bind_mode = v.bind_mode.join(',')

    return v
  }

  deleteNotice () {
    this.isPrivate ? this.deleteConfirm('') : this.verifyPhone({
      title: '删除认证方式',
      action: EVerifyPhoneAction.DELETE_CERTIFICATION_WAY,
      cb: this.deleteConfirm
    })
  }

  deleteConfirm (open_ssid:string) {
    this.open_ssid = open_ssid
    const dialogBody = `
      <div>
        <div style="font-weight: 600">确定要删除认证方式吗？</div>
        <div>认证方式删除后立即生效，认证信息将被清空，第三方账号将无法通过该认证方式登录WPS，请谨慎操作</div>
      </div>
    `
    this.$dialog.show({
      title: '删除认证方式',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        { text: '确定',
          type: 'primary',
          fn: this.deleteAuth
        }
      ]
    })
  }

  async deleteAuth () {
    try {
      await deleteAppAuthConfigs(this.appId, this.open_ssid)
      this.$dialog.close()
      this.$message.success('删除成功')
      await this.loadAppAuthConfigs()
    } catch (error) {
      onRequestError(error)
    }
  }
}
